export const imgRespSettings = {
    rellaxClass: 'rellax',
    target: '.img-responsive:not(.blockquote-bg):not(.icon-img)',
    attr: {
        'data-rellax-speed':  -0.75,
        'data-rellax-percentage': 0.5
    }
}

export const blockQuoteSettings = {
    rellaxClass: 'rellax-image',
    target: '.img-responsive.blockquote-bg',
    attr: {
        'data-rellax-speed':  -1.75,
        'data-rellax-percentage': 0.5
    },
    rellaxSettings: {
        wrapper: 'figure',
        relativeToWrapper: true
    }
}

